import { ICategoryTypes, TCategoryType, IPropertiesOfPatchChangesForCategory } from 'types';

export const categoryTypes: ICategoryTypes[] = [
	{ categoryID: 'Default', categoryName: 'categoryTypeDefault' }, // Changing the name of the Type, change the name of the SVG.
	{ categoryID: 'Hidden', categoryName: 'categoryTypeHidden' },
	{ categoryID: 'Game', categoryName: 'categoryTypeGame' },
	{ categoryID: 'Lunch', categoryName: 'categoryTypeLunch' },
	{ categoryID: 'Takeaway', categoryName: 'categoryTypeTakeaway' },
	{ categoryID: 'AdditionalIngredients', categoryName: 'categoryTypeAdditionalIngredients' },
	{ categoryID: 'Alcohol', categoryName: 'categoryTypeAlcohol' },
	{ categoryID: 'Commission', categoryName: 'categoryTypeCommission' },
	{ categoryID: 'ComboItems', categoryName: 'categoryTypeComboItems' },
	{ categoryID: 'ServiceCharge', categoryName: 'categoryTypeServiceCharge' },
	{ categoryID: 'Charity', categoryName: 'categoryTypeCharity' },
	{ categoryID: 'Children', categoryName: 'categoryTypeChildren' },
];

export const typesOfCategoriesDeniedForClientManagers: TCategoryType[] = [
	'Game',
	'Commission',
	'ServiceCharge',
	'Charity',
];

export const properties: IPropertiesOfPatchChangesForCategory[] = [
	{ id: 'activation', name: 'activation' },
	{ id: 'deactivation', name: 'deactivation' },
];
